import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMuted } from '../../../store/slices/controlSlice';
import Button from '@mui/material/Button';
import { Icon } from '../../Icons';
import styles from './VideoSettingsDialog.module.css';

function VolumeIndicatorButton() {
  const dispatch = useDispatch();
  const muted = useSelector((state) => state.control.muted);
  const audioLevel = useSelector((state) => state.device.audioLevel);
  return (
    <Button
      className={styles.testButton}
      color="newgreen"
      variant="contained"
      style={{
        ...(!muted && {
          backgroundImage: `linear-gradient(to top, rgba(38, 120, 109) ${audioLevel}%, rgba(30, 91, 83, 1) ${audioLevel}%)`,
        }),
      }}
      onClick={() => {
        dispatch(toggleMuted());
      }}
    >
      <Icon name={muted ? 'micOff' : 'micOn'} color="white" />
    </Button>
  );
}

export default VolumeIndicatorButton;
